import * as React from 'react'
import { FC, Fragment, memo } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'
import AddButton from '@organisms/AddButton'
import { memoEqual } from '@utils/memo'
import { AddButtonWrapper, Container } from './styled'
import DangersFieldsBlock from './DangersFieldsBlock'

const DangersFields: FC = () => {
  const { control } = useFormContext()

  const { fields, append, remove } = useFieldArray({
    name: 'dangerDTOs',
    control,
  })

  const handleAdd = () => {
    append({})
  }

  return (
    <Container>
      {fields.map((field, index, array) => (
        <Fragment key={field.id}>
          {window.ENABLE_LOGS && <h1>{index + 1}</h1>}
          <DangersFieldsBlock
            key={field.id}
            index={index}
            id={field.id}
            remove={remove}
            isLast={index === array.length - 1}
          />
        </Fragment>
      ))}
      <AddButtonWrapper>
        <AddButton id="risk-map-danger-add" onClick={handleAdd}>
          Добавить опасность
        </AddButton>
      </AddButtonWrapper>
    </Container>
  )
}

export default memo(DangersFields, memoEqual)
